export const healthGPTRoute = 'https://curefy.ai/gp';
export const curefyRoute = 'https://curefy.ai/en';
